/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pll_New_Err_Material_QtyInputs */

const vi_pll_new_err_material_qty = /** @type {(inputs: Pll_New_Err_Material_QtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập số lượng vật tư`)
};

/**

* @param {Pll_New_Err_Material_QtyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pll_new_err_material_qty = /** @type {((inputs?: Pll_New_Err_Material_QtyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pll_New_Err_Material_QtyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pll_new_err_material_qty(inputs)
});